import {
  CONSOLIDATED_MIS_REQUEST,
  CONSOLIDATED_MIS_SUCCESS,
  CONSOLIDATED_MIS_FAIL,
} from '../constants/consolidatedMisConstants';

export const consolidatedMisReducer = (state = { rows: [], loading: false, error: null }, action) => {
  switch (action.type) {
    case CONSOLIDATED_MIS_REQUEST:
      return { ...state, loading: true, error: null };
    case CONSOLIDATED_MIS_SUCCESS:
      return { loading: false, rows: action.payload, error: null };
    case CONSOLIDATED_MIS_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
